import * as React from 'react';
import DefaultInput from './index';
const SmarttagControl = ({ input: { value, onChange }, id, availableSmarttags, className, meta: { touched, error }, getSmarttagsKeys, getSmarttagsValues, getSmarttagsByFts, readOnly, ...restProps }) => {
    const arrayValue = Array.isArray(value) ? value : [];
    return (React.createElement(DefaultInput, { onChange: onChange, value: arrayValue, id: id, availableSmarttags: availableSmarttags, className: className, error: error && touched, getSmarttagsKeys: getSmarttagsKeys, getSmarttagsValues: getSmarttagsValues, getSmarttagsByFts: getSmarttagsByFts, readOnly: readOnly, ...restProps }));
};
export default SmarttagControl;
